import { defineStore } from 'pinia';

export const usePlaylistStore = defineStore('playlist', {
  state: () => ({
    live: null,
    radio: null,
    program: null,
  }),
  getters: {
    getLive: (state) => state.live,
    getRadio: (state) => state.radio,
    getProgram: (state) => state.program,
  },
  actions: {
    async initLive() {
      if(this.live === null) {
        try {
          this.live = await this.updateAPIData('/api/live')
        } catch(error) {
        // console.error('更新資料時出錯', error);
        }
      }
    },
    async initRadio() {
      if(this.radio === null) {
        try {
          this.radio = await this.updateAPIData('/api/radio')
        } catch(error) {
        // console.error('更新資料時出錯', error);
        }
      }
    },
    async initProgram() {
      if(this.program === null) {
        try {
          this.program = await this.updateAPIData('/api/program')
        } catch(error) {
        // console.error('更新資料時出錯', error);
        }
      }
    },
    async updateAPIData(fetchItem: string) {
      const res = await $fetch(fetchItem)
      return res
    },
  }
});